import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/auth";
import { PageHeader } from "@/pages/Classes";
import { sanitizeHtml } from "@/lib/sanitize";
import { BlogShareBar } from "@/components/BlogShareBar";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => { api.get(`/blog/${slug}`).then(r => setPost(r.data)).catch(() => setMissing(true)); }, [slug]);
  const content = post?.content || "";
  const isHtml = useMemo(() => /<[a-z][\s\S]*>/i.test(content), [content]);
  const paragraphs = useMemo(() => content.split(/\n{2,}|\n/).filter(Boolean).map((text, i) => ({ id: `${i}-${text.slice(0, 24)}`, text })), [content]);

  if (missing) return <div className="pt-40 pb-20 text-center text-zinc-500" data-testid="blog-post-missing">Post not found.</div>;
  if (!post) return <div className="pt-40 text-center text-zinc-500">Loading…</div>;
  return (
    <article data-testid="blog-post">
      <PageHeader eyebrow={post.category || "Story"} title={post.title} sub={post.excerpt} back backTo="/blog" backLabel="All posts" />
      <div className="max-w-[860px] mx-auto px-4 sm:px-6 py-12">
        {post.cover && <img src={post.cover} alt="" className="w-full aspect-[16/9] object-cover mb-10" />}
        <p className="text-zinc-500 text-xs uppercase tracking-widest mb-8">by {post.author || "2RightFeet"}{post.created_at ? ` · ${new Date(post.created_at).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" })}` : ""}</p>
        {isHtml
          ? <div className="prose prose-invert prose-lg max-w-none rich-content" dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.content) }} data-testid="blog-post-content" />
          : <div className="text-zinc-300 text-lg leading-relaxed space-y-5" data-testid="blog-post-content">{paragraphs.map(p => <p key={p.id}>{p.text}</p>)}</div>}
        <BlogShareBar post={post} />
      </div>
    </article>
  );
}
